// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import * as WrapperCore from '@angular/core';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
import * as WrapperServices from '../generated/api/userManagement.service';
// </generated-client-wrappers:imports>
import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import {
  AccessCatalog,
  ManagedUserDetail,
  ManagedUserSummary,
  PagedResult,
  UserAccessUpdateRequest,
  UserManagementQuery,
  UserManagementStatusRequest,
  UserTokenRevokeResult,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserManagementClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  queryUsers(query: UserManagementQuery): Observable<PagedResult<ManagedUserSummary>> {
    return this.http.post<PagedResult<ManagedUserSummary>>(OperationsApiRoutes.usersQuery, query, {
      context: this.quietContext,
    });
  }

  getUser(id: string): Observable<ManagedUserDetail> {
    return this.http.get<ManagedUserDetail>(OperationsApiRoutes.userById(id));
  }

  getUserAccessCatalog(): Observable<AccessCatalog> {
    return this.http.get<AccessCatalog>(OperationsApiRoutes.userAccessCatalog, {
      context: this.quietContext,
    });
  }

  blockUser(id: string, request: UserManagementStatusRequest): Observable<ManagedUserDetail> {
    return this.http.post<ManagedUserDetail>(OperationsApiRoutes.userBlock(id), request);
  }

  unblockUser(id: string, request: UserManagementStatusRequest): Observable<ManagedUserDetail> {
    return this.http.post<ManagedUserDetail>(OperationsApiRoutes.userUnblock(id), request);
  }

  updateUserRoles(id: string, request: UserAccessUpdateRequest): Observable<ManagedUserDetail> {
    return this.http.put<ManagedUserDetail>(OperationsApiRoutes.userRoles(id), request);
  }

  updateUserPermissions(id: string, request: UserAccessUpdateRequest): Observable<ManagedUserDetail> {
    return this.http.put<ManagedUserDetail>(OperationsApiRoutes.userPermissions(id), request);
  }

  revokeUserTokens(id: string, reason?: string): Observable<UserTokenRevokeResult> {
    return this.http.post<UserTokenRevokeResult>(OperationsApiRoutes.userRevokeTokens(id), { reason });
  }

  revokeUserToken(id: string, tokenId: string, reason?: string): Observable<UserTokenRevokeResult> {
    return this.http.post<UserTokenRevokeResult>(OperationsApiRoutes.userRevokeToken(id, tokenId), { reason });
  }
  // <generated-client-wrappers:methods>
  private readonly wrapperGeneratedClient = WrapperCore.inject(
    WrapperServices.UserManagementService,
    { optional: true },
  );

  block(
    id: string,
    request: WrapperApi.UserManagementStatusRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementBlock(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  get(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ManagedUserDetail> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementGet(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  getAccessCatalog(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AccessCatalogResponse> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementGetAccessCatalog(
      'body',
      reportProgress,
      options,
    );
  }

  query(
    request: WrapperApi.UserManagementQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ObservabilityPageOfManagedUserSummary> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementQuery(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  revokeToken(
    id: string,
    tokenId: string,
    request: WrapperApi.UserTokenRevokeRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementRevokeToken(
      id,
      tokenId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  revokeTokens(
    id: string,
    request: WrapperApi.UserTokenRevokeRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementRevokeTokens(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  unblock(
    id: string,
    request: WrapperApi.UserManagementStatusRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementUnblock(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  updatePermissions(
    id: string,
    request: WrapperApi.UserAccessUpdateRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementUpdatePermissions(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  updateRoles(
    id: string,
    request: WrapperApi.UserAccessUpdateRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.wrapperGeneratedClient)
      throw new Error('UserManagementService is not available');
    return this.wrapperGeneratedClient.userManagementUpdateRoles(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
